export const API_BASE_URL =
    process.env.REACT_APP_API_URL || "https://srv829925.hstgr.cloud";

export function getSessionToken() {
    try {
        return JSON.parse(localStorage.getItem("session"))?.password || "";
    } catch (error) {
        return "";
    }
}

export function authHeaders(headers = {}) {
    const token = getSessionToken();

    return {
        ...headers,
        ...(token ? { Authorization: "Bearer " + token } : {})
    };
}
